function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createAutocompleteActions } from 'swag-client-common/redux/partials/autocomplete/autocomplete.action';
import { setAddressAction } from 'swag-client-common/redux/partials/shipping-form/shipping-form.actions';
import { showLoader, hideLoader } from '../../../common/common.actions';
import { shippingAddressValuesSelector } from '../../giveaway-landing.selectors';
const {
  getPlaceById,
  getAddressByPlace,
  getAddresses,
  setManualAddressEnter
} = createAutocompleteActions({
  showAction: showLoader,
  hideAction: hideLoader,
  setAddressAction
});
export const getAddressesAction = () => (dispatch, getState) => {
  const state = getState();
  const values = shippingAddressValuesSelector(state);
  if (!values.address) {
    return true;
  }
  dispatch(getAddresses({
    country: values.country,
    place: values.address
  }));
};
export const getAddressByPlaceAction = params => (dispatch, getState) => {
  const values = shippingAddressValuesSelector(getState());
  dispatch(getAddressByPlace(_objectSpread({}, params, {
    country: values.country
  })));
};
export const getPlaceByIdAction = getPlaceById;
export const setManualAddressEnterAction = setManualAddressEnter;